export enum MaterialItemListStatusClass {
    success = 'icon-tick-circle',
    warning = 'icon-Warning-important',
    danger = 'icon-error-severe',
    info = 'icon-info',
}
